export default __webpack_public_path__ + "static/logos-hp-b36fe1845153ef693e36c148f0dfa609.png";